import React from "react";
import { Div } from "@vkontakte/vkui";
import styles from "./WeekDayRow.style";
import { weekDays_short } from "../../../variables";

const WeekDayRow = ({ firstDay }) => {
  const getWeekDays = () => {
    return weekDays_short.slice(firstDay, firstDay + 7);
  };

  return (
    <Div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingLeft: "0",
        paddingRight: "0",
        paddingTop: "16px",
      }}
    >
      {getWeekDays().map((wd) => {
        return (
          <Div style={{ ...styles.weekday }} key={wd}>
            {wd}
          </Div>
        );
      })}
    </Div>
  );
};

export default WeekDayRow;
